const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '基本信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '标段/标包信息',
        },
    },
    {
        component: 'ZlmTabDetail',
        options: {
            title: '包件',
            data: [],
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '会议地点',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
]

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        getData() {
            this.$request.post(`/transformToAfter/app/track/zbggOverview`, {
                bdGuid: this.$route.query.id,
            }, { showLoading: true }).then((res) => {
                this.getGGBdList(res.data.ggGuid)

                this.$request.post(`/transformToAfter/app/pre/bid/queryHuiYiYuYuePageList`, {
                    'bdName': res.data.bdName,
                    'meetingAddress': '',
                    'meetingStatus': 0,
                    'meetingType': '',
                    'pageNo': 1,
                    'pageSize': 1,
                    'sort': '',
                }, { showLoading: true }).then((hyListRes) => {
                    const hyList = hyListRes.data.rows || []
                    // TODO 还要调一个查看会议详情的接口，现在没有
                    const data = hyList[0] || {}
                    this.config[1].options.data = {
                        '会议类型': data.hylx,
                        '会议名称': '',
                        '会议开始时间': this.$util.timeFormatter(data.startTime),
                        '预计会议结束时间': this.$util.timeFormatter(data.endTime),
                        '设备总数': '',
                        '场地是否独占': '',
                    }
                    this.config[5].options.data = {
                        '会议室名称': data.huiYiShiNames,
                        '所属地区': '',
                        '详细地址': '',
                        '所属单位': '',
                    }
                })
            })
        },
        getGGBdList(guid) {
            this.$request.post(`/transformToAfter/app/track/announce/queryggBdList`, {
                ggGuid: guid,
            }).then((res) => {
                if (res.data && res.data.list) {
                    this.config[3].options.data = res.data.list.map((t) => ({
                            '包件名称': t.bdName,
                            '包件编号': t.bdBH,
                            '文件获取开始时间': this.$util.timeFormatter(t.bmStartTime),
                            '文件获取截止时间': this.$util.timeFormatter(t.bmEndTime),
                            '澄清截止时间': '',
                            '截标/开标时间': this.$util.timeFormatter(t.kbTime),
                            '标书获取地点': '',
                            '开标地点': '',
                            '采购范围': '',
                            '资格条件': '',
                        }))
                }
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
